import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

interface ListMercuryTransactionsQueryOptions {
  outstanding?: Ref<boolean | undefined>;
  posted_after?: Ref<string | undefined>;
  posted_before?: Ref<string | undefined>;
  limit?: Ref<number | undefined>;
  offset?: Ref<number | undefined>;
}

export const listMercuryTransactionsQuery = (
  options: ListMercuryTransactionsQueryOptions = {},
) => {
  return queryOptions({
    queryKey: [
      "mercury-transactions",
      "list",
      options.outstanding,
      options.posted_after,
      options.posted_before,
      options.limit,
      options.offset,
    ],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["listMercuryTransactions"][200]
    > =>
      handleClientMethod(
        getClient().GET("/mercury-transactions", {
          params: {
            query: {
              outstanding: options.outstanding?.value,
              posted_after: options.posted_after?.value,
              posted_before: options.posted_before?.value,
              limit: options.limit?.value,
              offset: options.offset?.value,
            },
          },
        }),
      ),
  });
};
